import { useContext, useState } from "react";

import classes from "./IngredientContentsPage.module.css";

import IngredientReferenceLine from "./IngredientReferenceLine/IngredientReferenceLine";

import CabinetContext from "../../../../store/cabinet-context";

// component for page containing all ingredients in book
const IngredientContentsPage = (props) => {
  // states are either total ingredient amount or shopping list (net amount)
  const [showShopping, setShowShopping] = useState(false);

  /*ingredients are stored in an object and therefore need to iterate 
  through the object for each individual ingredient*/
  const ingredientsObject = props.ingredients;
  const keys = Object.keys(ingredientsObject);

  // use cartCtx to calculate shopping list quantities
  const cabinetCtx = useContext(CabinetContext);
  const cabItems = cabinetCtx.items;

  // total ingredient volumes for book cocktails
  const totalIngredients = keys.map((key, index) => {
    //get indivdual ingrediet from ingredients object and pass to component
    const ingredient = ingredientsObject[key];

    return <IngredientReferenceLine key={index} ingredient={ingredient} />;
  });

  // net ingredients volumes that need to be shopped for
  // eslint-disable-next-line array-callback-return
  const shoppingIngredients = keys.map((key, index) => {
    //get indivdual ingrediet from ingredients object and pass to component
    const ingredient = ingredientsObject[key];

    const cabIngredient = cabItems.find((item) => item._id === ingredient._id);

    // calculate the shopping list volume
    var shopping_volume = ingredient.volume;
    if (cabIngredient) {
      shopping_volume = ingredient.volume - cabIngredient.volume;
      console.log(ingredient.title, " cabinet_volume: ", cabIngredient.volume);
    }

    // only return ingredients with positive volume
    if (shopping_volume > 0) {
      return (
        <IngredientReferenceLine key={ingredient.id} ingredient={ingredient} />
      );
    }
  });

  const switchToShoppingHandler = () => {
    setShowShopping(!showShopping);
  };

  return (
    <div className={classes.contents_page}>
      <div className={classes.contents_header}>
        <div className={classes.title}>INGREDIENT</div>
        <div className={classes.quantity}>QUANTITY</div>
      </div>
      <div className={classes.contents_body}>
        <div className={classes.line_separator} />
        {showShopping ? shoppingIngredients : totalIngredients}
      </div>
      <div className={classes.contents_footer}>
        <div
          className={classes.showShopButton}
          onClick={switchToShoppingHandler}
        >
          {showShopping ? "SHOW TOTALS" : "SHOW SHOPPING"}
        </div>
      </div>
    </div>
  );
};

export default IngredientContentsPage;
